// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTechnologyVideoSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.177 4C15.736 4 17 5.343 17 7v10c0 1.657-1.264 3-2.824 3H3.825C2.264 20 1 18.657 1 17V7c0-1.657 1.264-3 2.824-3zm4.093 6.203 3.333-3.667c.535-.588 1.397-.133 1.397.737V17c0 .824-.784 1.294-1.333.8l-3.334-3A1.079 1.079 0 0 1 18 14v-3.06c0-.28.098-.548.27-.737z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTechnologyVideoSolid;
